import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { UtilService } from "../../../shared/services/util.service";
import { DeslocamentoApiService } from "../shared/deslocamento-api.service";
import {CustoDeslocamento} from "../shared/deslocamento.model";

@Component({
    selector: 'app-custo-deslocamento-form-list',
    template: require('./custo-deslocamento-form-list.component.html'),
    styles: [require('./custo-deslocamento-form-list.component.css')]
})
export class CustoDeslocamentoFormListComponent implements OnInit {
    @Input() list: any[] = [];
    @Input() deslocamentoId: number;

    newObject: any = {};
    submitted: boolean = false;
    total: any;

    form2: FormGroup;
    descricao = new FormControl('', Validators.required);
    valor = new FormControl('', Validators.required);
    observacao = new FormControl('');
    comprovante = new FormControl('');

    constructor(
        private _deslocamentoApiService: DeslocamentoApiService,
        private _utilService: UtilService,

        private _fb: FormBuilder
    ) {
        this.form2 = _fb.group({
            descricao: this.descricao,
            valor: this.valor,
            observacao: this.observacao,
            comprovante: this.comprovante
        });
    }

    ngOnInit() {
        var t: number = 0.0;
        this.list.forEach(function(item: any) {
            if (item.valor) {
                t += item.valor;
            }
        });

        this.total = t;
        this.newItem();
    }

    clickRemove(item: any) {
        let onDelete = (function() {
            this.onRemoveCusto(item.id);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    keyupCurrency(start?: boolean) {
        let valor: number = this._utilService.currencyFormat(this.newObject.valor, start);
        if (valor) {
            this.newObject.valor = valor;
        }
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            let object: CustoDeslocamento = this._utilService.cloneObject(this.newObject);
            object.deslocamentoId = this.deslocamentoId;

            if (object.valor) {
                object.valor = this._utilService.getCurrency(object.valor);
            }

            this.onAddCusto(object);
        }
    }

    private newItem() {
        var object: any = {
            ativo: true
        };
        this.newObject = object;
    }

    private onAddCusto(object: CustoDeslocamento) {
        let onDone = (function (Response: any) {
            if (!Response.error)  {
                this.total += Response.valor;
                this.list.push(Response);

                this.newItem();
                this.submitted = false;

                this._utilService.swalMessageAddSuccess();
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        this._deslocamentoApiService.onPostCustoDeslocamento(object, onDone);
    }

    private onRemoveCusto(objectId: number) {
        let onDone = (function (Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === objectId) {
                        this.list[x].ativo = false;
                        this.total -= this.list[x].valor;
                        break;
                    }
                }

                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageWarningCustom(Response.error);
            }
        }.bind(this));

        this._deslocamentoApiService.onDeleteCustoDeslocamento(objectId, onDone);
    }


}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/custo-deslocamento-form-list/custo-deslocamento-form-list.component.ts
 **/